import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ZiroModalPromptModalOptions } from '../prompt-modal/prompt-modal.component';
import { ButtonStyles } from '../../button/button.component';
import { TranslateService } from '@ngx-translate/core';
import { ZiroModalService } from '../../shared/services/ziro-modal.service';
import { ZiroIcons, ZiroStackedIcons } from '../../shared/models/ziro-icons.enum';
import { MicrosoftBulkJob } from '../../shared/models/generated/ziroModels';

@Injectable()
export class MigrationsBulkJobMigrationModalService {
  private _translateService = inject(TranslateService);
  private _ziroModalService = inject(ZiroModalService);

  openNavigationModal(draft: MicrosoftBulkJob, isExisting: boolean, tenantId?: number): Observable<any> {
    const options: ZiroModalPromptModalOptions = {
      windowClass: 'dn-report-redirect-modal',
      modalViewProperties: {
        title: this._translateService.instant(
          isExisting
            ? 'tkey;migrations.cisco.directory_numbers_report.modal_redirect.title.label.updated'
            : 'tkey;migrations.cisco.directory_numbers_report.modal_redirect.title.label.created',
        ),
        promptBody: this._translateService.instant(
          isExisting
            ? 'tkey;migrations.cisco.directory_numbers_report.modal_redirect.prompt.content.updated'
            : 'tkey;migrations.cisco.directory_numbers_report.modal_redirect.prompt.content.created',
          { name: draft.bulkJobName },
        ),
        iconStacked: ZiroStackedIcons[ZiroIcons.BULK],
        displayCloseButton: true,
        buttons: [
          {
            label: this._translateService.instant(
              'tkey;migrations.cisco.directory_numbers_report.modal_redirect.redirect.label',
              { name: draft.bulkJobName },
            ),
            buttonIcon: ZiroIcons.EXTERNAL_LINK,
            buttonClass: ButtonStyles.DEFAULT,
            dataAutomation: 'dn-report-redirect-modal-navigate-button',
            cb: () => {
              window.open(`/app2/#/automations/tenants/${tenantId}/bulk-provisioning/${draft.id}`, '_blank');
              return of(null);
            },
          },
          {
            label: 'tkey;migrations.cisco.directory_numbers_report.modal_redirect.stay.label',
            buttonClass: ButtonStyles.PRIMARY,
            dataAutomation: 'dn-report-redirect-modal-stay-button',
            cb: () => {
              return of(null);
            },
          },
        ],
      },
    };
    return this._ziroModalService.openPromptModal(() => options.modalViewProperties, options);
  }
}
